module.exports = [
  {
    title: {
      de: 'Aufträge managen',
      en: 'Manage orders',
      es: 'Gestionar pedidos',
      fr: 'Management des commandes',
      pt: 'Gerir os pedidos',
      it: 'Gestione degli ordini',
      ru: 'Управление заказами'
    },
    url: 'Projects',
    subViews: [
      'OrderDetails'
    ],
    icon: 'home'
  },
  {
    title: {
      de: 'Daten bereitstellen',
      en: 'Upload data',
      es: 'Cargar datos',
      fr: 'Fourniture des données',
      pt: 'Disponibilizar os dados',
      it: 'Caricamento dei dati',
      ru: 'Формирование данных'
    },
    url: 'NewProject',
    subViews: [
      'ProjectDetails',
      'UploadStl'
    ],
    icon: 'cog'
  },
  {
    title: {
      de: 'Reports generieren',
      en: 'Generate report',
      es: 'Generar Informe',
      fr: 'Générer des rapports',
      pt: 'Criar relatórios',
      it: 'Genera report',
      ru: 'Создание отчетов'
    },
    url: 'Orders',
    index: 'inprogress',
    subViews: [],
    icon: 'inbox'
  },
  {
    title: {
      de: 'Infothek nutzen',
      en: 'Use Infothek',
      es: 'Utilizar la infoteca',
      fr: 'Utiliser l`Infothèque',
      pt: 'Utilizar a infoteca',
      it: 'Utilizzo di Infothek',
      ru: 'Использование Infothek'
    },
    url: 'Infothek',
    icon: 'comments'
  },
  {
    id: 'addons',
    title: {
      de: 'Zusatzprodukte',
      en: 'Additional products',
      es: 'Productos adicionales',
      fr: 'Produits supplémentaires',
      pt: 'Produtos adicionais',
      it: 'Prodotti supplementari',
      ru: 'Дополнительная продукция'
    },
    url: 'ProjectDetails',
    index: 'new:addons',
    icon: 'inbox'
  }
];
